import { Favourites as FavouritesComponent } from "@/app/modules/Playlists/";
import { ErrorPage } from "@/components";
import { useAppProperties } from "@/hooks";

export const Favourites = () => {
  const { showFavourites, isLoading } = useAppProperties();

  if (!isLoading && !showFavourites) {
    return <ErrorPage code={404} />;
  }

  return <FavouritesComponent />;
};
